import { getAPI } from "./axios-base";
import Admin from "@/models/Admin";

interface GetAdminsParams {
  skip: number;
  limit: number;
  q: string;
  name: string;
  email: string;
}
export default class RestResourceAdmin {
  getAdmins(params: GetAdminsParams) {
    return getAPI.get(`api/rest/v1/user`, { params });
  }
  getAdmin(id: string) {
    return getAPI.get(`api/rest/v1/user/${id}`);
  }
  putAdmin(id: string, body: Admin) {
    return getAPI.put(`api/rest/v1/user/${id}`, body);
  }
  getSuperAdmins(params: GetAdminsParams) {
    return getAPI.get(`api/rest/v1/user`, { params });
  }
}
